

stringUtil = exports

stringUtil.toFunction = (str) ->
    return stringUtil.toElementIn(str, window)


stringUtil.toElementIn = (str, obj) ->
    arr = str.split('.')

    fn = obj

    for v, i in arr
        fn = fn[v]

    if not fn?
        throw new Error("couldn't find #{str}")

    return fn


stringUtil.setElementIn = (str, value, obj) ->
    arr = str.split('.')

    fn = obj

    for v, i in arr

        if i is arr.length - 1
            fn[v] = value
        else
            if fn[v]? and not (typeof fn[v] is 'object')
                throw new Error("Can't descend into #{fn[v]}, it's not an object.")

            if not fn[v]?
                fn[v] = {}


        fn = fn[v]

    return fn


stringUtil.studlyCase = (str) ->
    str = stringUtil.camelCase str

    return stringUtil.capitalize(str)


stringUtil.camelCase = (str) ->
    str = stringUtil.allLower(str)
    arr = str.split /[, -_]/

    tail    = List.map ( (x) -> stringUtil.capitalize x ), List.tail arr
    head    = [List.head(arr)]
    arr     = head.concat tail

    return arr.join('')



stringUtil.capitalize = (str) ->
    return str.charAt(0).toUpperCase() + str.slice(1)


stringUtil.allLower = (str) ->
    return str.replace /.*/g, ( (x) -> return x.toLowerCase())

stringUtil.allUpper = (str) ->
    return str.replace /.*/g, ( (x) -> return x.toUpperCase())

stringUtil.studlyToWords = (str) ->
    return str.replace(/([A-Z])/g, ' $1' )


stringUtil.contains = (str, val) ->
    if str.indexOf(val) isnt -1
        return true

    return false

stringUtil.startsWith = (str, val) ->
    if str.match("^#{val}")?
        return true

    return false

stringUtil.endsWith = (str, val) ->
    if str.match("#{val}$")?
        return true

    return false
